module.exports = __webpack_public_path__ + "img/Nyromantikk_Andre_kunstformer2.f5cc7b08.jpg";